var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSymbol = function SvgSymbol(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.6912,
    height: 78.6912,
    viewBox: "0 0 78.6912 78.6912",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M76.6912,2V76.6912H2V2H76.6912m2-2H0V78.6912H78.6912V0h0Z",
    style: {
      fill: "#7c8eb8"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M44.8865,41.8561c2.6261,1.4827,4.3176,2.7244,4.62,6.0508,.0078,.0858-.0095,.1583-.0071,.2412l3.8938,2.7179c.9601-3.799-.4138-8.6875-3.6579-10.9327-3.6194-2.5047-11.0771-4.5425-10.7005-10.0551,.397-5.813,7.2315-4.6457,10.5893-2.7332,2.3082,1.3147,4.3848-2.2629,2.0771-3.5771-3.5775-2.0375-7.5574-3.0521-11.4603-1.4101-4.0078,1.6862-6.0336,5.896-5.1417,10.177,1.0179,4.8847,5.8482,7.2974,9.7873,9.5213h0Z",
    style: {
      fill: "#7c8eb8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.522,51.409c-2.863,1.6835-7.8813,1.5764-8.7526,1.5308-1.2613-.0661-2.8711-.4384-4.0913-1.0065-1.5166-.7048-2.7016-1.6884-3.5573-2.9493-.855-1.2603-1.2832-2.6855-1.2832-4.2771V23.6811c0-.6899-.2178-1.2528-.6528-1.6884-.435-.435-.9977-.6528-1.6884-.6528-.6601,0-1.2156,.2178-1.6654,.6528-.4505,.4356-.6758,.9984-.6758,1.6884v21.0259c0,2.4318,.623,4.5923,1.8684,6.4836,1.2454,1.8907,2.9864,3.3701,5.2228,4.4348,1.9421,.9253,3.6213,1.3685,6.523,1.5695,4.1969,.2273,9.5888-.5821,12.5699-3.1213l-3.8173-2.6646h0Z",
    style: {
      fill: "#7c8eb8"
    }
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSymbol);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/symbol.c47c229b3684318970c2a257e42a13d2.svg";